import ApiClient from './ApiClient'

export default class NowSettingsClient extends ApiClient {
    update = ({ params }) => this.put(`/now/settings`, params)
}
